import { useEffect } from "react";
import { addCartItems } from "actions/cart";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "@reach/router";

// Allows to add products to cart from URL, example: ?updates[39408405446736]=10&[39696893247568]=4
const useURLToCart = () => {
	const dispatch = useDispatch();
	const location = useLocation();
	const { checkoutUrl, items } = useSelector(state => state.cart);

	const cartItemIds = Object.keys(items);
	const shopifyGid = "gid://shopify/ProductVariant/";

	useEffect(() => {
		if (!checkoutUrl) return;
		const searchParams = new URLSearchParams(location.search);

		const parsedProducts = Array.from(searchParams.entries()).reduce((parsed, [key, value]) => {
			const match = key.match(/^\[(\d+)\]$/);
			if (match) {
				const variantId = match[1];
				const quantity = parseInt(value, 10);
				return [...parsed, { id: variantId, quantity }];
			} else if (key.startsWith("updates[")) {
				const variantId = key.match(/\[(\d+)\]/)[1];
				const quantity = parseInt(value, 10);
				return [...parsed, { id: variantId, quantity }];
			}
			return parsed;
		}, []).filter(({ id }) => !cartItemIds.includes(`${shopifyGid}${id}`)); // Do not add to cart if already exist

		// TODO: Change the logic here, maybe add an extra param to determine whether is one-time or recurring
		if (parsedProducts.length > 0) {
			dispatch(
				addCartItems(
					parsedProducts.map(({ id, quantity }) => ({
						id: `${shopifyGid}${id}`,
						quantity,
					})),
				),
			);
		}
	}, [checkoutUrl]);
};

export default useURLToCart;
